import React from "react";
import { motion } from "framer-motion";

const AUTHORS = [
  {
    name: "Sanket Apte",
    role: "Creator",
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/41pn284c_Gemini_Generated_Image_.png",
    quote:
      "I wanted a book I could read to my child that treated their mind the way we treat their small hands — carefully, kindly, and with room to grow.",
    bio: "A parent who spent too many evenings explaining what a bank was. This series began as a single scribbled question on the back of a receipt: \"How do I teach them, gently?\" Every book is the answer to a real question a real child asked — paired with playful activities that turn each idea into practice.",
  },
  {
    name: "Shruti Kulkarni",
    role: "Co-creator",
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/0b8lrt9w_Gemini_Generated_Image_6qdz5a6qdz5a6qdz%20%281%29.webp",
    quote:
      "Children don't need us to simplify the world — they need us to show it to them, slowly, and let them figure it out themselves.",
    bio: "Shruti brings the second voice to Maya's stories — the careful editor's ear, the structure behind every gentle sentence, and the activities that turn each lesson into practice. She shapes each book so young readers walk away with real financial literacy, one small idea at a time.",
  },
];

function AuthorCard({ person, index }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, delay: index * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
      className="col-span-12 md:col-span-6"
      data-testid={`author-card-${index}`}
    >
      <div className="arch-frame aspect-[4/5] overflow-hidden">
        <img
          src={person.image}
          alt={`${person.name} — ${person.role}`}
          className="w-full h-full object-cover"
          data-testid={`author-image-${index}`}
        />
      </div>
      <div className="mt-5 flex items-baseline justify-between border-b border-stone-900/15 pb-3">
        <p className="font-serif text-3xl md:text-4xl leading-none">{person.name}</p>
        <span className="folio-num">{person.role}</span>
      </div>
      <blockquote className="mt-6 border-l-2 border-stone-900/40 pl-6">
        <p className="font-serif italic text-xl md:text-2xl leading-snug text-stone-800">
          &ldquo;{person.quote}&rdquo;
        </p>
      </blockquote>
      <p className="mt-6 text-[15px] md:text-[16px] leading-relaxed text-stone-700">
        {person.bio}
      </p>
    </motion.article>
  );
}

export default function AuthorSection() {
  return (
    <section id="author" className="section" data-testid="author-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-20"
        >
          <div className="col-span-12 md:col-span-4">
            <p className="folio-num">Colophon · The Creators</p>
          </div>
          <h2
            className="col-span-12 md:col-span-8 font-serif text-4xl sm:text-5xl md:text-7xl leading-[0.9] tracking-tight"
            data-testid="author-heading"
          >
            Two voices, one <em className="italic" style={{ color: "var(--accent-orange)" }}>steady handrail</em> for little readers.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-10 md:gap-16">
          {AUTHORS.map((p, i) => (
            <AuthorCard key={p.name} person={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
